import { render } from "./ActivityCenterFeatureTabs.vue?vue&type=template&id=e28caef0&scoped=true"
import script from "./ActivityCenterFeatureTabs.vue?vue&type=script&lang=js"
export * from "./ActivityCenterFeatureTabs.vue?vue&type=script&lang=js"

import "./ActivityCenterFeatureTabs.vue?vue&type=style&index=0&id=e28caef0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e28caef0"]])

export default __exports__